import { styled, Box } from "@mui/material";


export const TitleText = styled(Box)(({ theme }) => ({
  marginRight:"auto",
  textAlign:'left',
  fontFamily: 'FinancierDisplay',
  fontSize: '2rem',
  overflow: 'hidden',
  cursor: 'default',
}));
  
  
  
export const Action = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));